module.exports = __webpack_public_path__ + "media/images/athletes/1674-ff56cd5cd4876fb6b28d859cf8f4f8a8.png";